import styles from './index.css'

const TitleDescription = () => {
  return (
    <ol className={styles.imageDesc}>
      <li className={styles.highlight}>
        進倉商品的品名如果涉及尺寸、規格⋯等文字修改，且該商品在庫仍有庫存，請待庫存銷售完畢或申請退倉後再修改，避免客訴爭議。
      </li>
      <li>由於提案和修改過程中會有時間差，可能造成賣場/商品資訊舊值和目前線上賣場/商品資訊的值已不相同，遇此情況系統仍會執行提案單內新值的內容。</li>
      <li>提案送出後，將立即執行並更新賣場。</li>
    </ol>
  )
}

export default TitleDescription
